<template>
    <section>
        <section class="card-container" style="height: 500px;">
            <h1>404 {{ $t('error.not_found') }}</h1>
            <router-link :to="{'name':'index'}">{{ $t('menu.home') }}</router-link>
        </section>
    </section>
</template>

<script>
export default {
    head: {
        title: function() {
            return {
                inner: `404 ${this.$i18n.t('error.not_found')}`,
                separator: '|',
                complement: this.$i18n.t('main.museum_name')
            }
        },
        meta: function() {
            return []
        }
    }
}
</script>
